import clsx from 'clsx';
import React, { ReactNode } from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';

import ActionButton from '../../Elements/ActionButton/ActionButton';

type AutomationBannerProps = {
  children: ReactNode;
  onClose?: (event?: any) => void;
  isShowNewExpenseForm?: boolean;
  isShowAutomationBanner?: boolean;
};

const AutomationBanner = ({ children, onClose, isShowNewExpenseForm }: AutomationBannerProps) => {
  return (
    <div
      className={clsx(
        'automationBanner--container',
        isShowNewExpenseForm ? 'tw-bg-[rgba(96,174,238,0.05)]' : 'tw-bg-[rgba(151,71,255,0.05)]',
        'tw-py-[15px] tw-px-[25px]',
        onClose && 'tw-flex tw-items-center tw-justify-between'
      )}
    >
      <p className={clsx('tw-text-cfo-black tw-text-[12px]', 'tw-flex tw-items-center')}>
        {children}
      </p>

      {onClose && (
        <ActionButton
          className={clsx('!tw-p-0 !tw-m-0')}
          buttonType="style_unset"
          onClick={onClose}
        >
          <Icon icon={ICONS.close} className={clsx('tw-text-[18px]')} />
        </ActionButton>
      )}
    </div>
  );
};

export default AutomationBanner;
